import styled from 'styled-components'
import {useState, useEffect} from 'react'
import {useHistory} from 'react-router-dom'
import {useMutation} from '@apollo/client'
import updateUser from '../../graphql/updateUser'
import getUser from '../../graphql/getUser'
import Heading from '../Heading/Heading'
import Button from '../Button/Button'
import useAuth from '../../hooks/useAuth'
import ScreenLoader from '../ScreenLoader/ScreenLoader'
import {validate} from '../UserForm/NewUser'
import {
  Wrapper,
  Box,
  Col,
  Row,
  Label,
  Input,
  ErrorMsg,
  btnStyles,
} from '../UserForm/NewUser'
import InputMask from 'react-input-mask';
import { useQuery } from '@apollo/client'

const EditWrapper = styled(Wrapper)`
  @media only screen and (max-width: 920px) {
    margin-top: 10px;
  }
`

const RecommendationEmailTitleStyle = {
  fontWeight: "bold"
}
const RecommendationEmailSubtitleStyle = {
  fontWeight: "lighter" // todo this does not work because we don't have a file for "light" Aeonik.
}
const recommendationEmailIsEnabledRowStyle = {
  paddingLeft: 20,
  paddingTop: 20,
  paddingBottom: 60,
}
styled(Button)`
  margin-left: auto;
  background-color: red;

  &:hover {
    background-color: #e60505;
  }
`;
const MaskedInputBox = (props) => (
  <InputMask value={props.form.phone} name="phone" mask="999-999-9999" onChange={props.handleChange}>
    {(inputProps) => <Input {...inputProps}/>}
  </InputMask>
);

const EditProfile = () => {
  const history = useHistory()
  const {selectedOrg, user: JWTtokenInfo } = useAuth()
  const userId = JWTtokenInfo.user_id.split("|")[1]
  const userIdPrefixed = "u:" +  userId
  const { data: userInfo, loading: userLoading } = useQuery(getUser, {
    variables: { id: userIdPrefixed },
  })
  const [update, {loading, error}] = useMutation(updateUser)
  const [isSubmitting, setSubmitting] = useState(false)
  const [form, setForm] = useState({
    firstName: '',
    lastName: '',
    roles: [''],
  })
  const [errors, setErrors] = useState({})
  const organizationId = selectedOrg.value
  const user = userInfo?.getUser
  const refetchQueries = [
    {query: getUser, variables: {id: userIdPrefixed}},
  ]

  useEffect(() => {
    if (user)
      setForm({
        firstName: user.firstName,
        lastName: user.lastName,
        roles: JWTtokenInfo['https://harbortrek10/organizations'][0]["roles"],
        recommendationEmailIsEnabled: user.recommendationEmailIsEnabled ?? false,
        phone: user.phone ?? null,
      })
  }, [user, userInfo, JWTtokenInfo])

  if (userLoading) return <ScreenLoader/>
  if (error) return <ErrorMsg>{error.message}</ErrorMsg>

  const handleChange = e => {
    const {name, value, checked} = e.target

    const newValues = {
      ...(name.includes('roles')
        ? {
          [name]: checked
            ? [...form.roles, value]
            : [...form.roles].filter(role => role !== value),
        }
        : {[name]: value}),
    }
    if (name === 'recommendationEmailIsEnabled') {
      newValues[name] = checked;
    }
    setForm(prev => ({...prev, ...newValues}))
  }

  const handleSubmit = async () => {
    try {
      const errors = validate(form)
      if (errors) return setErrors(errors)
      setErrors({})
      setSubmitting(true)
      const variables = {
        organizationId,
        id: userId,
        firstName: form.firstName,
        lastName: form.lastName,
        roles: form.roles,
        recommendationEmailIsEnabled: form.recommendationEmailIsEnabled,
        phone: form.phone || null, // consider '' as null.
      }
      await update({variables, refetchQueries})
      setSubmitting(false)
      history.push('/')
    } catch (err) {
      console.log(err)
    }
  }
  return (
    <EditWrapper>
      <Row>
        <Heading>Edit Profile</Heading>
      </Row>
      <Box>
        <Col>
          <Label>First Name</Label>
          <Input
            name='firstName'
            value={form.firstName}
            onChange={handleChange}
          />
          {errors.firstName && <ErrorMsg>{errors.firstName}</ErrorMsg>}
        </Col>
        <Col>
          <Label>Last Name</Label>
          <Input
            name='lastName'
            value={form.lastName}
            onChange={handleChange}
          />
          {errors.lastName && <ErrorMsg>{errors.lastName}</ErrorMsg>}
        </Col>
        <Col>
          <Label>Email (Contact support@trek10.com to update email)</Label>
          <Input disabled defaultValue={user?.email}/>
        </Col>
        <Col>
          <Label>Mobile Phone # (for MFA user verification)</Label>
          <MaskedInputBox
            form={form}
            handleChange={handleChange}
          />
          {errors.phone && <ErrorMsg>{errors.phone}</ErrorMsg>}
        </Col>
        <Col>
          <Label>Roles</Label>
          <Row>
            <input
              type='checkbox'
              defaultChecked={JWTtokenInfo['https://harbortrek10/organizations'][0]["roles"].includes('admin'.toUpperCase())}
              id='roles'
              name='roles'
              value={'admin'.toUpperCase()}
              onChange={handleChange}
              disabled={true}
            />
            <label htmlFor='roles'>Admin</label>
          </Row>
        </Col>
      </Box>
      <Row>
        <Heading>Notifications</Heading>
      </Row>
      <Row style={recommendationEmailIsEnabledRowStyle}>
        <input
          type='checkbox'
          defaultChecked={user?.recommendationEmailIsEnabled}
          id="recommendationEmailIsEnabled"
          name='recommendationEmailIsEnabled'
          onChange={handleChange}
        />
        <label htmlFor='recommendationEmailIsEnabled'>
          <p style={RecommendationEmailTitleStyle}>Recommendation Email</p>
          <p style={RecommendationEmailSubtitleStyle}>Suggested by Expert Architects to optimize your environment</p>
        </label>
      </Row>
      <Row>
        <Button isSecondary onClick={() => history.push('/users')}>
          Cancel
        </Button>
        <Button disabled={loading} isSubmitting={isSubmitting} onClick={handleSubmit} style={btnStyles}>
          Save
        </Button>
      </Row>
    </EditWrapper>
  )
}

export default EditProfile
